import SkillsGapAnalysisIntro from '../views/sections/Intro.vue';
import SkillsGapAnalysisTasks from '../views/sections/Tasks.vue';
import SkillsGapAnalysisEducation from '../views/sections/Education.vue';
import SkillsGapAnalysisWorkHistory from '../views/sections/WorkHistory.vue';
import SkillsGapAnalysisCertifications from '../views/sections/Certifications.vue';
import SkillsGapAnalysisActivities from '../views/sections/Activities.vue';
import SkillsGapAnalysisKnowledge from '../views/sections/Knowledge.vue';
import SkillsGapAnalysisEssentialSkills from '../views/sections/EssentialSkills.vue';
import SkillsGapAnalysisTechnologies from '../views/sections/Technologies.vue'
import SkillsGapAnalysisSkills from '../views/sections/Skills.vue';
import SkillsGapAnalysisHiddenTalents from '../views/sections/HiddenTalents.vue';
import SkillsGapAnalysisAdditionalInfo from '../views/sections/AdditionalInfo.vue';
import SkillsGapAnalysisQR from '../views/sections/QR.vue';
import SkillsGapAnalysisPrivacy from '../views/sections/Privacy.vue';
import MainSection from '../views/sections/MainSection.vue';

export default [{
  path: '/',
  component: MainSection,
  // meta: {
  //   requiredRole: process.env.VUE_APP_ROLE_EMPLOYEE,
  // },
  children: [
    {
    path: '',
    name: 'sgaIntro',
    component: SkillsGapAnalysisIntro,
    meta: {
      type: 'small',
      label: 'Intro',
      currentPage: 1
    }
    },
    {
    path: '2',
    name: 'sgaTasks',
    component: SkillsGapAnalysisTasks,
    meta: {
      type: 'split',
      label: 'Tasks',
      currentPage: 2
    }
    },
    {
    path: '3',
    name: 'sgaEducation',
    component: SkillsGapAnalysisEducation,
    meta: {
      type: 'small',
      label: 'Education',
      currentPage: 3
    }
    },
    {
      path: '4',
      name: 'sgaWorkHistory',
      component: SkillsGapAnalysisWorkHistory,
      meta: {
        type: 'small',
        label: 'Work History',
        currentPage: 4
      }
      },
    {
    path: '5',
    name: 'sgaCertifications',
    component: SkillsGapAnalysisCertifications,
    meta: {
      type: 'small',
      label: 'Certifications',
      currentPage: 5
    }
    },
    {
    path: '6',
    name: 'sgaActivities',
    component: SkillsGapAnalysisActivities,
    meta: {
      type: 'small',
      label: 'Activities',
      currentPage: 6
    }
    },
    {
    path: '7',
    name: 'sgaKnowledge',
    component: SkillsGapAnalysisKnowledge,
    meta: {
      type: 'small',
      label: 'Knowledge',
      currentPage: 7
    }
    },
    {
      path: '8',
      name: 'sgaTechnologies',
      component: SkillsGapAnalysisTechnologies,
      meta: {
        type: 'split',
        label: 'Technologies',
        currentPage: 8
      }
      },
    {
    path: '9',
    name: 'sgaEssentialSkills',
    component: SkillsGapAnalysisEssentialSkills,
    meta: {
      type: 'split',
      label: 'Essential Skills',
      currentPage: 9
    }
    },
    
    {
    path: '10',
    name: 'sgaSkills',
    component: SkillsGapAnalysisSkills,
    meta: {
      type: 'small',
      label: 'Skills',
      currentPage: 10
    }
    },
    {
      path: '11',
      name: 'sgaHiddenTalents',
      component: SkillsGapAnalysisHiddenTalents,
      meta: {
        type: 'small',
        label: 'Hidden Talents',
        currentPage: 11
      }
    },
    {
      path: '12',
      name: 'sgaAdditionalInfo',
      component: SkillsGapAnalysisAdditionalInfo,
      meta: {
        type: 'small',
        label: 'Additional Information',
        currentPage: 12
      }
    },
    {
      path: 'thankyou',
      name: 'sgaQR',
      component: SkillsGapAnalysisQR,
      meta: {
        type: 'small',
        label: 'Thank You',
        currentPage: 13
      }
    },
    {
    path: 'privacy',
    name: 'sgaPrivacy',
    component: SkillsGapAnalysisPrivacy,
    meta: {
      type: 'small'
    }
    }
  ]
  }
];
